import React from 'react';
import PropTypes from 'prop-types';
import { Button } from "../../../common/button";
import { ThumbsUp, ThumbsDown, AlertCircle, Info, FileText } from "lucide-react";

const ResultDisplay = ({ result, onFeedback, feedbackSubmitted }) => {
  return (
    <div className="mt-4 space-y-6">
      {/* 추천 분개 */}
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-semibold mb-4">추천 분개</h3>
        
        {/* 차변 계정과목 */}
        <div className="mb-6">
          <h4 className="font-medium text-gray-700 mb-2">추천 계정과목(차변):</h4>
          <div className="space-y-2">
            {result.debit_accounts.map((account, index) => (
              <div key={`debit-${index}`} className="p-3 bg-gray-50 rounded-md">
                <div className="flex justify-between items-center">
                  <span className="font-medium">{account.name}</span>
                  <span className="text-gray-600">{account.amount}</span>
                </div>
                {account.description && (
                  <p className="text-sm text-gray-600 mt-1">{account.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* 대변 계정과목 */}
        <div className="mb-6">
          <h4 className="font-medium text-gray-700 mb-2">추천 계정과목(대변):</h4>
          <div className="space-y-2">
            {result.credit_accounts.map((account, index) => (
              <div key={`credit-${index}`} className="p-3 bg-gray-50 rounded-md">
                <div className="flex justify-between items-center">
                  <span className="font-medium">{account.name}</span>
                  <span className="text-gray-600">{account.amount}</span>
                </div>
                {account.description && (
                  <p className="text-sm text-gray-600 mt-1">{account.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* 선택 이유 */}
        {result.explanation && (
          <div className="mt-4 p-4 bg-blue-50 rounded-md">
            <h4 className="font-medium text-gray-700 mb-2 flex items-center">
              <Info className="h-4 w-4 mr-2" />
              선택 이유:
            </h4>
            <p className="text-sm text-gray-600">{result.explanation}</p>
          </div>
        )}

        {/* 주의사항 */}
        {result.cautions && result.cautions.length > 0 && (
          <div className="mt-4 p-4 bg-yellow-50 rounded-md">
            <h4 className="font-medium text-gray-700 mb-2 flex items-center">
              <AlertCircle className="h-4 w-4 mr-2" />
              주의사항:
            </h4>
            <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
              {result.cautions.map((caution, index) => (
                <li key={index}>{caution}</li>
              ))}
            </ul>
          </div>
        )}

        {/* 세무 고려사항 */}
        {result.taxConsiderations && result.taxConsiderations.length > 0 && (
          <div className="mt-4 p-4 bg-green-50 rounded-md">
            <h4 className="font-medium text-gray-700 mb-2 flex items-center">
              <FileText className="h-4 w-4 mr-2" />
              세무 고려사항:
            </h4>
            <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
              {result.taxConsiderations.map((consideration, index) => (
                <li key={index}>{consideration}</li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* 피드백 버튼 */}
      {!feedbackSubmitted && (
        <div className="flex justify-center space-x-4">
          <Button
            onClick={() => onFeedback(true)}
            className="flex items-center text-green-600 hover:text-green-700"
          >
            <ThumbsUp className="mr-2 h-4 w-4" />
            정확해요
          </Button>
          <Button
            onClick={() => onFeedback(false)}
            variant="outline"
            className="flex items-center text-red-600 hover:text-red-700"
          >
            <ThumbsDown className="mr-2 h-4 w-4" />
            부정확해요
          </Button>
        </div>
      )}
    </div>
  );
};

ResultDisplay.propTypes = {
  result: PropTypes.shape({
    debit_accounts: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      amount: PropTypes.string,
      description: PropTypes.string
    })).isRequired,
    credit_accounts: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      amount: PropTypes.string,
      description: PropTypes.string
    })).isRequired,
    explanation: PropTypes.string,
    cautions: PropTypes.arrayOf(PropTypes.string),
    taxConsiderations: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  onFeedback: PropTypes.func.isRequired,
  feedbackSubmitted: PropTypes.bool.isRequired
};

export default ResultDisplay; 